import { ICreateCustomerQuotePartsPayload } from 'chatbot/types';
import { postJson, TPostJsonOptions } from 'core/services';

export const createCustomerQuoteParts = async (
  payload: ICreateCustomerQuotePartsPayload,
  options: TPostJsonOptions
) =>
  postJson(
    '/quote/api/create-customer-quote-parts',
    payload as unknown as Record<string, unknown>,
    options
  );
